<template>
  <component
    :is="interactive ? 'button' : 'span'"
    :type="interactive ? 'button' : undefined"
    class="workspace-tag-chip"
    :class="{
      'workspace-tag-chip--filled': selected,
      'workspace-tag-chip--interactive': interactive
    }"
    :style="chipStyle"
    @click="onClick"
  >
    <span class="workspace-tag-chip__icon">{{ getTagIcon(tag.icone) }}</span>
    <span class="workspace-tag-chip__name">{{ tag.nome }}</span>
  </component>
</template>

<script setup>
import { computed } from 'vue'
import { getTagIcon } from '@/utils/iconMapper'
import { getContrastColor } from '@/utils/colorContrast'

const props = defineProps({
  tag: { type: Object, required: true },
  selected: { type: Boolean, default: true },
  interactive: { type: Boolean, default: false }
})

const emit = defineEmits(['click'])

const chipStyle = computed(() => {
  if (!props.selected) return {}
  const cor = props.tag.cor || '#6366f1'
  return {
    backgroundColor: cor,
    color: getContrastColor(cor)
  }
})

const onClick = (event) => {
  if (!props.interactive) return
  emit('click', event)
}
</script>

<style src="@/assets/styles/workspace-tag-chip.css"></style>
